<template>
  <div>
    <v-card
      class="d-flex"
      :class="[$vuetify.breakpoint.mobile ? 'flex-column' :'flex-row', listeGrainesAAfficher === null && !$vuetify.breakpoint.mobile ? 'card-recolte' : '']"
      elevation="1"
    >
      <div
        class="d-flex justify-center"
        :class="$vuetify.breakpoint.mobile ? 'flex-row my-3' :'flex-column ml-6 mr-4'"
      >
        <div
          class="align-self-center"
        >
          <v-icon
            size="x-large"
            color="primary"
          >
            mdi-calendar-blank
          </v-icon>
        </div>

        <div
          class="align-self-center"
          :class="$vuetify.breakpoint.mobile ? 'mx-2' :''"
        >
          <span
            class="texte primary--text"
          >Récolte {{ itemSelected }}</span>
        </div>
        <div
          class="align-self-center"
        >
          <v-icon
            color="primary"
            @click="isOpenSelectRecolte = !isOpenSelectRecolte"
          >
            {{ isOpenSelectRecolte ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </div>
      </div>
      <NavMenuGraineCulturial
        v-if="listeGrainesAAfficher && isPageOutilAnalyse"
        v-model="codeGraineSelected"
        class="ma-1"
        :loading="loading"
        :has-choix-toutes-cultures="hasChoixToutesCultures"
        :graines="listeGrainesAAfficher"
        :annee-recolte-selected="itemSelected"
        @change="selectGraine"
      />
      <NavMenuGraine
        v-if="listeGrainesAAfficher && !isPageOutilAnalyse"
        v-model="codeGraineSelected"
        class="ma-2"
        :loading="loading"
        :graines="listeGrainesAAfficher"
        @change="selectGraine"
      />
    </v-card>

    <v-card
      v-if="isOpenSelectRecolte"
      v-click-outside="onClickOutside"
      class="mt-2 select-recolte"
      :class="listeGrainesAAfficher != null ? 'select-recolte-graine' : 'select-recolte-sans-graine'"
    >
      <v-list
        v-for="(item, index) in listeAnneesRecoltes"
        :key="index"
        class="no-padding"
      >
        <v-list-item @click="onClick(item)">
          <span class="action text-truncate primary--text">Récolte {{
            item
          }}</span>
        </v-list-item><v-divider v-if="listeAnneesRecoltes.length > index + 1" />
      </v-list>
    </v-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import NavMenuGraine from '@/components/nav/nav-menu-graine.vue'
import NavMenuGraineCulturial from '../nav/nav-menu-graine-culturial.vue'

export default {
  name: 'BaseSelectAnneeRecolte',
 components: {NavMenuGraine, NavMenuGraineCulturial},
  props: {
    listeAnneesRecoltes: {
      type: Array,
      required: true
    },
    listeGrainesAAfficher: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    codeGraineSelected: {
      type: String,
      default: null
    },
    hasChoixToutesCultures: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isOpenSelectRecolte: false,
      itemSelected: null,
      anneeRecolteSelected: null
    }
  },
  computed: {
    ...mapGetters({
      anneeRecolteEnCours: 'application/anneeRecolteEnCours',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive'
    }),
    isPageOutilAnalyse () {
      return this.$route.name === 'main.mes-outils-d-analyse' || this.$route.name === 'main.saisie-contrats-adherent'
    },
  },
  created () {
    this.anneeRecolteSelected = this.anneeRecolteActive!= null ? this.anneeRecolteActive : this.anneeRecolteEnCours
    this.itemSelected = this.anneeRecolteSelected
  },
  methods: {
    onClick (item) {
      this.itemSelected = item
      this.isOpenSelectRecolte = false
      this.$emit('selectAnneeRecolte', item)
    },
    selectGraine (value) {
      this.$emit('selectGraine', value)
    },
    onClickOutside () {
      this.isOpenSelectRecolte = false
    }
  }
}
</script>

<style lang="scss" scoped>
.no-padding {
  padding: 0;
}
.v-list-item:hover {
  background-color: #e0e0e0 !important;
}

.select-recolte {
  position: static;
  width: auto;
}

.card-recolte  {
  height: 90px;
}

@media only screen and (min-width: 600px) {

  .select-recolte-graine {
    position: absolute;
    width: 125px;
    z-index: 100;
    top: 220px;
  }

  .select-recolte-sans-graine {
    position: absolute;
    width: 125px;
    z-index: 100;
    top: 185px;
  }
}
</style>